<div class="wrap">
  <h1>MENTIONS LEGALES & CONDITIONS GÉNÉRALES D'UTILISATION</h1>
  <h2>I-MENTIONS LEGALES</h2>
  <h3>1) Propriétaire du site</h3>
  <div class="infos">
    <div class="img">
      <img _ngcontent-hmj-c72="" src="assets/img/icon-blue/logo FFV.svg" alt="FFVoile">

    </div>
    <div class="content">
      <span><strong>Fédération Française de Voile</strong></span><br><br>

      <span style="margin-bottom: 10px;">
        17, rue H. Bocquillon<br>
        75015 PARIS<br>
        Tel : 01 40 60 37 00<br>
        Fax : 01 40 60 37 37<br>
      </span><br>

      <span>Directeur de la publication : Nicolas HENARD, Président de la FFVoile</span><br><br>

      <span> Co-directeur de la publication : Eric MARLIOT, Directeur administratif, juridique et financier</span>
    </div>

  </div>

  <h3>2) Crédits</h3>
  <p>Gestion, conception, réalisation, hébergement : © Fédération Française de Voile</p>
  <h2>II-CONDITIONS GÉNÉRALES D'UTILISATION</h2>
  <h3>1) Objet</h3>
  <p>
    Les présentes conditions générales d’utilisation (CGU) ont vocation à régir l’utilisation du site web de la
    Fédération Française de Voile (http://www.ffvoile.fr).
    Elles concernent également l’Espace Licencié (accessible aux détenteurs d’une licence de la Fédération) et l’Espace
    Club (accessible aux structures affiliées à la Fédération).
    Ces conditions générales d’utilisation s’appliquent à tous les visiteurs des sites mentionnés ci-dessus, et
    notamment aux licenciés de la Fédération, aux représentants des structures affiliées et des organismes déconcentrés
    de la Fédération et plus généralement à tous les acteurs intervenant dans le champ fédéral ou visiteurs
    occasionnels.
    La Fédération peut autoriser sous conditions contractualisées l’accès à certaines fonctionnalités via des
    Webservices à des partenaires techniques ou prestataires tiers pour optimiser sa gestion administrative ou sportive.

    Tous ces différents acteurs sont dénommés dans les présentes conditions sous le terme de « Utilisateurs ».
    Les gestionnaires de la Fédération sont responsables du contenu et de la mise à jour ou de l’exactitude des
    informations qu’ils communiquent ou mettent à la disposition des Utilisateurs au moyen du site et des Espaces
    Licencié et Club.
  </p>
  <h3>2) Acceptation des CGU</h3>
  <p>
    L’utilisation du site implique l’acceptation sans réserve des présentes Conditions Générales d’Utilisation (« CGU
    »).
    La Fédération se réserve le droit de modifier à tout moment les CGU, qui sont disponibles pour examen à chaque
    utilisation du site. Au cas où l’une quelconque des dispositions des CGU serait considérée comme nulle, les autres
    clauses des CGU demeureront de plein effet.
  </p>
  <h3>3) Conditions d’accès au site et aux Espaces Licenciés & Clubs</h3>
  <p>
    La Fédération s’engage à rendre disponible le site dans le cadre d’une utilisation normale.

    La Fédération ne garantit pas la conformité du site à un usage ou besoin spécifique, ni un fonctionnement exempt
    d’interruptions, d’erreurs, de perturbations, de virus ou défaillances quelle qu’en soit la cause, cas de force
    majeure, fait d’autrui ou autre, ni la véracité, la fiabilité ou l’exactitude des informations mises en ligne ou la
    qualité des Services ou la conformité des Services ou des résultats recherchés aux attentes de l’Utilisateur.

    La responsabilité de la Fédération ne saurait notamment pas être engagée si le site était indisponible pour des
    raisons de force majeure telles que notamment, sans que cette liste ne soit limitative, défaillance du réseau public
    d’électricité, grève, tempêtes, guerres, tremblements de terre, défaillance du réseau public des télécommunications,
    perte de connectivité internet dues aux opérateurs publics et privés. La Fédération s’engage à faire tout son
    possible pour rétablir l’accès au site dans les plus brefs délais à compter de la fin de l’évènement de force
    majeure.

    L’Utilisateur fera tout son possible pour informer immédiatement la Fédération lorsqu’il aura connaissance ou
    constatera un dysfonctionnement du site.
    Si la Fédération a des motifs légitimes de penser que la sécurité du site est violée par un Utilisateur ou
    contournée avec des moyens d’identification non autorisée, elle pourra procéder à la suspension temporaire du compte
    afin notamment de préserver l’intégrité du site et des données, et, si cela apparaît approprié, exiger la
    modification de ces moyens d’identification.
  </p>
  <h3>4) Responsabilité & propriété intellectuelle</h3>
  <p>
    Les droits d'auteurs des contenus présents sur les pages identifiées par le nom de domaine "ffvoile.fr",
    "ffvoile.net", "ffv.fr" et les sous-domaines qui leur sont associés sont détenus en exclusivité par la Fédération
    Française de Voile.

    L'ensemble de ce site relève de la législation française en matière de propriété intellectuelle française, et
    notamment le droit d'auteur, les droits voisins, le droit à l'image, le droit des marques etc ...

    En conséquence de quoi, toute représentation et/ou reproduction et/ou exploitation totale ou partielle de ce site et
    de son contenu, par quelques procédés que ce soit, sans l'autorisation préalable et expresse de la Fédération
    Française de Voile, est interdite et constituerait une contrefaçon sanctionnée notamment par les articles L 335-2 et
    suivants du Code de la propriété Intellectuelle, et/ou un acte de concurrence déloyale et/ou un acte de parasitisme
    susceptible d'engager la responsabilité des personnes qui s'y sont livrées.
  </p>
  <h3>5) Conditions d’utilisation du site et des Espaces Licencié & Club</h3>

  <div>
    <p>
      D’une manière générale, l’Utilisateur s’interdit, dans le cadre de l’utilisation du site et de l’accès aux Espaces
      Licencié et Club, de se livrer à des actes, de quelque nature que ce soit, tels que l’émission, l’édition, la mise
      en ligne ou la diffusion de données et/ou de contenus qui seraient contraires à la loi, porteraient atteinte à
      l’ordre public, ou aux droits de la Fédération ou de tiers.

      En particulier, sans que cette liste ne soit limitative, l’Utilisateur s’engage, dans son utilisation du site et
      des
      Espaces Licenciés et Clubs, à respecter les règles suivantes :
    </p>
    <ul>
      <li>Ne pas se connecter avec l’identifiant et le mot de passe d’un autre Utilisateur ;</li>
      <li>Ne pas diffuser son identifiant et mot de passe à des tiers ;</li>
      <li>Signaler tout contenu à caractère illicite, dont il pourrait avoir connaissance;</li>
      <li>Communiquer / saisir des informations exactes ;</li>
      <li>Se conformer aux lois en vigueur et respecter les droits des tiers, ainsi que les stipulations des présentes
        CGU ;</li>
      <li>Utiliser le site et les Espaces Licencié et Club de manière loyale, conformément à leur finalité
        exclusivement, et</li>
      conformément aux dispositions légales en vigueur et ne pas diffuser des données, informations ou contenus à
      caractère diffamatoire, injurieux, obscène, offensant, à caractère pornographique ou contenant de la nudité,
      violent ou incitant à la violence, ou à caractère politique, raciste ou xénophobe et de manière générale tout
      contenu qui serait contraire aux lois et règlements en vigueur ou aux bonnes mœurs.
      <li>Ne pas stocker de données en local dans le but d’effectuer des traitements sans l’accord écrit préalable de la
      </li>
      Fédération.
      <li>Répondre dans les meilleurs délais à toute demande d’information de la part de la Fédération en cas de litige
        ;</li>
    </ul>
    <p>
      En cas de manquement par un Utilisateur au présent article, la Fédération se réserve le droit de suspendre et/ou
      de
      résilier unilatéralement l’accès au site et aux Espaces Licencié et Club, de bloquer le(s) compte(s) de
      l’Utilisateur concerné ou de supprimer automatiquement les contenus litigieux, sans qu’aucune indemnisation ne
      puisse être due.
    </p>
  </div>
  <h3>6) Protection des données</h3>
  <h4>a)Loi informatique et libertés</h4>
  <p>
    Le Site a fait l'objet d'une déclaration auprès de la Commission nationale informatique et libertés (CNIL) - N° de
    déclaration CNIL : 1599506 v 0.

    Les Utilisateurs du Site sont tenus de respecter les dispositions de la loi informatique, fichiers et libertés, dont
    la violation est passible de sanctions pénales. Ils doivent notamment s'abstenir, s'agissant des informations
    nominatives auxquelles ils accèdent, de toute collecte, de toute utilisation détournée, et d'une manière générale de
    tout acte susceptible de porter atteinte à la vie privée ou à la réputation des personnes.

    Les données personnelles (c’est-à-dire toute information relative à une personne physique permettant d’identifier
    directement ou indirectement celle-ci via un ou plusieurs éléments qui lui sont propres) traitées par la FFVoile
    sont
    conformes à la loi « Informatiques et Libertés » du 6 janvier 1978 modifiée et au Règlement n° 2016/679, dit
    règlement
    général sur la protection des données (RGPD).
  </p>

  <h4>b)Traitement des données personnelles</h4>
  <p>
    Le traitement des données personnelles des Utilisateurs, et notamment des licenciés, a pour objet de permettre à la
    Fédération d’exécuter pleinement la mission de service public dont elle est investie et la réalisation de son objet
    statutaire.
    Dans le cadre de l’adhésion à la FFVoile (licence), de la participation aux manifestations et des abonnements aux
    newsletters, certaines données personnelles des Utilisateurs figurent actuellement dans notre base de contacts. Il
    s’agit de <strong>données d’identification</strong> et <strong>de données sportives</strong>.

    <strong>Les données d’identification</strong> (nom, adresse, adresse e-mail, numéro de téléphone, date de naissance)
    sont utilisées
    pour les traitements suivants :
  </p>
  <ul>
    <li>Licences : commande, gestion, suivi, relances.</li>
    <li>Analyse (anonymisée) des pratiques (licenciés ou non)</li>
    <li>Enquêtes, sondages</li>
    <li>Informations générales et légales aux licenciés actifs et inactifs en application des statuts et des obligations
    </li>
    <li>légales de la FFVoile</li>
    <li>Envoi de Communications FFVoile (newsletters / offres partenaires réservées aux licenciés)</li>
  </ul>
  <p>
    Ces données sont stockées pendant 30 ans à compter de la dernière prise de licence et sont destinées aux Services
    fédéraux, aux organes déconcentrés (ligues et Comités départementaux et club dans lequel la licence a été prise),
    aux
    prestataires aux fins de dispense de nos services (organisme collecteur de la licence, prestataires techniques pour
    la
    diffusion…). Le cas échéant ces données peuvent être requises par l’administration en vertu de la loi. Sauf
    exception
    pour laquelle un consentement sera requis aux fins de participation (lauréat d’un jeu-concours par exemple), les
    données personnelles des licenciés ne sont jamais transmises aux partenaires fédéraux.

    Les <strong>données sportives</strong> (Résultats en compétitions, formation dans une Ecole Française de Voile,
    enregistrement des
    certificats médicaux et questionnaire de santé…) sont stockées pendant 30 ans à compter de la dernière prise de
    licence, sont destinées aux services fédéraux, aux organes déconcentrés (Ligues et Comités départementaux et club
    dans
    lequel la licence a été prise), et aux prestataires aux fins de dispense de nos services (prestataires techniques de
    gestion des données sportives).

    L’Utilisateur participant à une compétition inscrite au calendrier fédéral accepte notamment que la Fédération
    publie
    sur le site les résultats de ladite compétition mentionnant son nom et prénom.
  </p>
  <h4>c) Accès, modification, rectification et suppression des données</h4>
  <p>
    Tout Utilisateur a un droit d'accès, de modification, de rectification et de suppression des données qui le
    concernent.

    La Fédération s’interdit toute revente à des tiers, des données nominatives relatives à l’Utilisateur sans son
    accord.
    Elle s’engage à traiter les données et à conduire ses actions de communication auprès de ses membres licenciés dans
    le
    respect de la réglementation.

    Les données d’identification et sportives sont accessibles via <strong>l’Espace Licencié</strong>. Un identifiant et
    un mot de passe
    permettent au licencié de disposer de services exclusifs. Cet identifiant est personnel et lié à son numéro de
    licence
    FFVoile. Le licencié s’interdit de divulguer son mot de passe à des tiers et mettra tout en œuvre pour empêcher
    l’accès ou l’utilisation de son compte par un tiers. En cas de manquement aux conditions générales d’utilisation ou
    d’irrégularités, la FFVoile se réserve la possibilité, sans mise en demeure préalable, de suspendre ou de fermer le
    compte Utilisateur concerné, et d’annuler les services proposés.

    Conformément au règlement général de protection des données (RGPD), toute personne ayant communiqué des données
    personnelles à la FFVoile peut exercer son droit d'accès aux données le concernant, les faire rectifier, les
    supprimer, les limiter, et selon les situations s’y opposer, en contactant <a
      href="mailto:dpo@ffvoile.fr">dpo@ffvoile.fr</a> ou par courrier au siège
    social de la Fédération Française de Voile en précisant que sa demande est relative aux données personnelles. La
    FFVoile s’engage à traiter la requête sous 30 jours à compter de la réception de la demande.
  </p>

  <h4>d) Collecte d'informations : emailings et listes de diffusion</h4>
  <p>
    Les Utilisateurs ont la possibilité de se désabonner des newsletters de la Fédération à tout moment en cliquant sur
    le
    lien présent dans toutes les newsletters transmises, ainsi que sur [l'Espace Licencié] si l’Utilisateur dispose
    d'une
    licence en cours de validité. Si l’Utilisateur n’est pas licencié à la FFVoile, il peut contacter la Fédération au
    01
    40 60 37 00 ou par mail <a href="mailto:dpo@ffvoile.fr">dpo@ffvoile.fr</a>

    Les adresses électroniques recueillies dans le cadre des différentes listes de diffusion ne sont utilisées que pour
    l'envoi des lettres d'information de la FFVoile et d'alertes ponctuelles.

    Les adresses électroniques ou autres informations nominatives dont la FFVoile serait destinataire via les appels à
    contributions ne feront l'objet d'aucune exploitation. Un modérateur est susceptible de supprimer toute contribution
    qui ne serait pas en relation avec le thème de discussion abordé, la ligne éditoriale du site, ou qui serait
    contraire
    à la loi.
  </p>

  <h4>e) Droit à l’oubli</h4>
  <p>
    Les Utilisateurs, et notamment les anciens licenciés de la Fédération, souhaitant que toute ou partie de leurs
    données
    personnelles soient supprimées peuvent adresser un e-mail à l’adresse dpo@ffvoile.fr ou par courrier au siège social
    de la Fédération Française de Voile en précisant que sa demande est relative aux données personnelles.
  </p>

  <h4>f) Google Analytics</h4>
  <p>
    Ce site Web utilise Google Analytics, un service analytique Web fourni par Google, Inc. (« Google »). Google
    Analytics
    utilise des « cookies » qui sont des fichiers texte placés sur votre ordinateur afin d’aider le site Web à analyser
    la
    manière dont les Utilisateurs font usage du site. Les informations générées par le cookie concernant votre
    utilisation
    du site Web (y compris votre adresse IP) sera transmise et stockée par Google sur ses serveurs aux États-Unis.
    Google
    utilisera ces informations aux fins d’évaluer votre utilisation du site Web, de compiler des rapports sur l’activité
    du site Web à destination des exploitants du site Web et de fournir d’autres services se rapportant à l’activité du
    site Web et à l’usage d’Internet. Google pourra également communiquer ces informations à des tiers lorsque cela est
    requis par la loi ou lorsque ces tiers traitent les informations pour le compte de Google. Google, s’engage à ne pas
    associer votre adresse IP à d’autres données détenues par Google. L’Utilisateur a la possibilité de refuser l’usage
    de
    cookies en sélectionnant les consignes requises sur son navigateur ; il convient de noter que s’il agit de la sorte,
    il est possible qu’il ne puisse plus utiliser la totalité des fonctionnalités de ce site Web. En utilisant ce site
    Web, l’Utilisateur accepte que Google traite des données le concernant de la manière et aux fins décrites ci-dessus.

    Afin que les internautes puissent décider plus librement de la manière dont Google Analytics collecte leurs données,
    la Société Google a développé un module complémentaire de désactivation pour navigateur. Ce module indique au
    fichier
    Javascript Google Analytics (ga.js) que les informations concernant la visite d'un site Web ne doivent pas être
    envoyées à Google Analytic.

    <a href="https://tools.google.com/dlpage/gaoptout?hl=fr">[Cliquez ici pour en savoir plus]</a>
  </p>

  <h4> g) Cookies</h4>
  <p>
    Différentes fonctionnalités telles que cookies, capture des variables d'environnement, etc. peuvent être exploitées
    afin de faciliter la navigation. Un cookie ne permet pas d’identifier l’Utilisateur. De manière générale, il
    enregistre des informations relatives à la navigation de son ordinateur sur le site (les pages consultées, la date
    et
    l'heure de la consultation, etc.) que la Fédération pourra lire lors de visites ultérieures de l’Utilisateur.
  </p>

  <h4>h) Recommandations techniques</h4>
  <p>
    Afin de proposer une plus grande compatibilité d'accès au site de la FFVoile, le présent site a été testé avec les
    navigateurs Internet Explorer, Firefox, Chrome et Safari.
  </p>
  <h3>7) Hyperliens</h3>

  <h4>a) Création de lien vers https://www.ffvoile.fr</h4>
  <p>
    Le site de la Fédération française de Voile autorise la mise en place d'un lien hypertexte pointant vers son contenu
    à l'exclusion des sites Internet diffusant des informations à caractère polémique, pornographique, xénophobe ou
    pouvant, dans une plus large mesure atteinte à la sensibilité du plus grand nombre, et sous réserve de :

    mentionner la source qui pointera grâce à un lien hypertexte directement sur le contenu visé de s'ouvrir dans une
    nouvelle fenêtre
    Une demande d'établissement de lien hypertexte vers le site de la FFVoile doit être faite par mail à
    webmaster@ffvoile.fr. Dans tous les cas, la Fédération Française de Voile se réserve le droit de refuser.
  </p>
  <h4>b) Lien vers un site tiers</h4>
  <p>
    Une demande d'établissement de lien hypertexte à partir du site de la FFVoile doit être faite par mail à
    webmaster@ffvoile.fr . Dans tous les cas, la Fédération Française de Voile se réserve le droit de refuser.

    Accéder à ces liens fait quitter le site de la FFVoile. Ces sites ne sont pas sous le contrôle de la Fédération, par
    conséquent cette dernière n'est pas responsable du contenu de ces sites, des liens qu'ils contiennent ni des
    changements ou des mises à jour qui leur sont apportés.
  </p>

  <h4>c) Demande d'autorisation et/ou de reproduction de tout ou partie du Contenu du Site</h4>
  <p>
    Pour reproduire tout ou partie du Contenu (images, articles, photos, logos, marques, vidéos, interviews, sons,
    textes, bases de données…) sur support électronique ou sur support papier, l’Utilisateur doit adresser une demande
    par courrier ou e-mail à :

    Fédération Française de Voile – Service Communication
    17, rue Henri BOCQUILLON
    75015 PARIS
    Email : webmaster@ffvoile.fr

    Il est demandé à l’Utilisateur de bien vouloir préciser le contexte, la durée souhaitée, la nature du site, la
    présentation envisagée…L’Utilisateur doit également préciser le nom, le nom de l'association ou entreprise,
    l'adresse URL du site, ainsi que ses coordonnées.
  </p>
</div>